import React from 'react';
import PropTypes from 'prop-types';

import ImageGallery from 'react-image-gallery';

const ShotCharts = ({ shotCharts }) => {
  const images = shotCharts.map(shotChart => ({
    original: shotChart.image,
    description: shotChart.description,
    originalTitle: shotChart.description,
    originalAlt: shotChart.description,
  }));

  return (
    <ImageGallery items={images} showThumbnails={false} showBullets={true} />
  );
};

ShotCharts.propTypes = {
  shotCharts: PropTypes.arrayOf(PropTypes.object),
};

export default ShotCharts;
